import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Layout from "../components/Layout";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Cart from "../pages/Cart/Cart";
import Product from "../pages/Products/Product";
import ProductList from "../pages/Products/ProductList";
import ReceiptPage from "../pages/CheckOut/ReceiptPage";

import StaticRoutes from "./StaticRoutes";
import AdminRoutes from "./AdminRoutes";

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="login-page" element={<Login />} />
          <Route path="product/:id" element={<Product />} />
          <Route path="products" element={<ProductList />} />

          {/* Checkout */}
          <Route path="checkout/shipping" element={<Cart />} />
          <Route path="receipt/:orderId" element={<ReceiptPage />} />

          <Route
            path="test"
            element={<div style={{ padding: "2rem" }}>✅ Test route works!</div>}
          />

          {StaticRoutes()}
          {AdminRoutes()}
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
